import { ReactNode } from "react";

interface DetailRowProps {
  label: string;
  value: ReactNode;
  /** Hide the bottom divider (use on the last row of a group). */
  last?: boolean;
}

// Label/value row, matched to the "Discover (A)" design (detail.jsx InfoRow):
// 10px/0 padding, hairline divider, 13px muted label, right-aligned
// 13.5px/500 value (or a control passed as a node).
export const DetailRow = ({ label, value, last = false }: DetailRowProps) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        padding: "10px 0",
        borderBottom: last ? "none" : "1px solid #EAECF0",
      }}
    >
      <span style={{ fontSize: 13, color: "#667085" }}>{label}</span>
      {typeof value === "string" ? (
        <span style={{ fontSize: 13.5, color: "#101828", fontWeight: 500, textAlign: "right" }}>
          {value}
        </span>
      ) : (
        value
      )}
    </div>
  );
};
